import {useInfiniteQuery, UseInfiniteQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {infiniteQueryFetchNextPage} from '@/utilities/helpers'
import {
    httpGetSiarBulkExportPreview,
    HttpGetSiarBulkExportPreviewParams,
    HttpGetSiarBulkExportPreviewResponse
} from '@/features/projects/siar-bulk-export/http/siarBulkExport.http'

export const useGetSiarBulkExportPreview = (
    params: Omit<HttpGetSiarBulkExportPreviewParams, 'page'>,
    options?: Pick<UseInfiniteQueryOptions<HttpGetSiarBulkExportPreviewResponse>, 'enabled'>
) => {
    const query = useInfiniteQuery({
        queryKey: [QUERY_KEYS.SIAR_BULK_EXPORT_PREVIEW, params],
        queryFn: ({pageParam = 1}) => httpGetSiarBulkExportPreview({...params, page: pageParam as number}),
        ...options,
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })

    return {
        ...query,
        fetchNextPage: () => infiniteQueryFetchNextPage(query),
        remappedData: query.data?.pages[0]?.items?.length ? query.data.pages.flatMap(page => page.items) : [],
        total: query.data?.pages[0]?.meta.total ?? 0
    }
}
